module.exports = __webpack_public_path__ + "img/gb-wave-logo.66840c3a.webp";